import React, { useEffect, useState } from "react";
import { request } from "../../../utils/request";
import { formatCurrency } from "../../../utils/helpers";
import Loader from "../../general/Loader";

const TarjetaCompras = ({anio, mes, vendedor, styles}) => {
    const tarjeta = "cardCompraDashboard";
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(true)

    const getData = async (anio,mes) => {
        setLoading(true);
        const req = await request(`dashboard/gi?tarjeta=${tarjeta}&mes=${mes}&anio=${anio}&vendedor=${vendedor ? 1 : 0}`);

        if (req.success) {
            setData(req.data);
            setLoading(false);
        }
    };

    useEffect(() => {
      getData(anio,mes);
    }, [anio, mes]);

    if (loading === true) {
        return <div style={styles.columnStyles}>
            <Loader />
        </div>;
    }

    return (
        <div style={styles.columnStyles}>
            <div style={styles.columnContainer}>
                <div style={styles.header}>
                    <div className="color-primary" style={styles.principal}>
                        {formatCurrency(data?.totalCompra)}
                    </div>
                    <div style={styles.subtitulo}>
                        Compras
                    </div>
                </div>

                <div className="row">
                    {data?.comprobante > 0 && (
                        <div style={styles.infoBlock}>
                            <div>
                                <strong><small className="badge badge-success">{data?.comprobanteCount}</small>  {formatCurrency(data.comprobante)}</strong>
                            </div>
                            <small style={styles.label}>Valor Fiscal</small>
                        </div>
                    )}
                    {data?.proforma > 0 && (
                        <div style={styles.infoBlock}>
                            <div>
                                <strong><small className="badge badge-success">{data?.proformaCount}</small> {formatCurrency(data.proforma)}</strong>
                            </div>
                            <small style={styles.label}>Proforma</small>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default TarjetaCompras;
